import { useState } from "react";
import { Link } from "react-router-dom";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-[#03060f]/90 backdrop-blur-sm text-white p-4 shadow-lg sticky top-0 z-50">
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="hover:opacity-80 transition duration-300">
          <img
            src="/morzetech.png"
            alt="Morse Tech Solutions Logo"
            className="h-12 md:h-14"
          />
        </Link>

        {/* Navigation Menu */}
        <nav className="hidden md:flex space-x-8">
          <Link to="/" className="hover:text-orange transition duration-300 font-semibold text-lg">Home</Link>
          <Link to="/about" className="hover:text-orange transition duration-300 font-semibold text-lg">About Us</Link>
          <Link to="/howwebuiltit" className="hover:text-orange transition duration-300 font-semibold text-lg">How We Built It</Link>
          <Link to="/careers" className="hover:text-orange transition duration-300 font-semibold text-lg">Careers</Link>
          <Link to="/contact" className="hover:text-orange transition duration-300 font-semibold text-lg">Contact</Link>
        </nav>

        {/* Mobile Menu Button (Hamburger Icon) */}
        <button
          className="md:hidden focus:outline-none"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <svg
            className="w-7 h-7"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            ></path>
          </svg>
        </button>
      </div>

      {/* Mobile Menu (Conditionally Rendered) */}
      {isMenuOpen && (
        <div className="md:hidden mt-2 bg-[#03060f]/95 backdrop-blur-sm rounded-lg">
          <nav className="flex flex-col">
            <Link 
              to="/" 
              className="p-4 hover:bg-orange/20 hover:text-orange transition duration-300 font-semibold text-base border-b border-gray-700/50"
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className="p-4 hover:bg-orange/20 hover:text-orange transition duration-300 font-semibold text-base border-b border-gray-700/50"
              onClick={() => setIsMenuOpen(false)}
            >
              About Us
            </Link>
            <Link 
              to="/howwebuiltit" 
              className="p-4 hover:bg-orange/20 hover:text-orange transition duration-300 font-semibold text-base border-b border-gray-700/50"
              onClick={() => setIsMenuOpen(false)}
            >
              How We Built It
            </Link>
            <Link 
              to="/careers" 
              className="p-4 hover:bg-orange/20 hover:text-orange transition duration-300 font-semibold text-base border-b border-gray-700/50"
              onClick={() => setIsMenuOpen(false)}
            >
              Careers
            </Link>
            <Link 
              to="/contact" 
              className="p-4 hover:bg-orange/20 hover:text-orange transition duration-300 font-semibold text-base"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}